import React from "react";

const TagButton = ({ tag, active, handleClick, removable }) => {
  return (
    <button
      className={`py-1 pl-4 bg-indigo-500   text-white text-xs rounded-full transition-colors truncate cursor-pointer font-semibold outline-none ${
        active ? "bg-indigo-700" : ""
      } ${removable ? "pr-2" : "pr-4"}`}
      onClick={() => handleClick(tag)}
    >
      {tag}
      {removable && (
        <span className="ml-2 pl-1 border-l-2 border-gray-300 text-gray-200 ">
          X
        </span>
      )}
    </button>
  );
};

export default TagButton;
